import { t } from "../i18n/t";

/** §B7.4: a busy indicator that announces itself rather than spinning silently. */
export function Spinner({ label }: { label?: string }): JSX.Element {
  return (
    <p className="spinner" role="status" aria-live="polite">
      {label ?? t("common.loading")}
    </p>
  );
}
